<template>
  <div class="malRemark">
    <el-card shadow="never">
      <div class="header-flex">
        <h1>穴位留言列表</h1>
        <div class="input-flex">
          <el-select
            v-model="dataType"
            placeholder="请选择数据类型"
            class="select-type"
          >
            <el-option
              v-for="item in stateList"
              :key="item.status"
              :label="item.name"
              :value="item.status"
            ></el-option>
          </el-select>
          <el-input
            placeholder="请输入搜索内容"
            prefix-icon="el-icon-search"
            v-model.lazy="keyword"
            clearable
            class="input"
          ></el-input>
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="content" label="用户留言"></el-table-column>
        <el-table-column prop="nick_name" label="用户昵称"></el-table-column>
        <el-table-column prop="avatar_url" label="用户头像">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.avatar_url"
              fit="fill"
              class="user-avatar"
              :preview-src-list="previewList"
              @click="previewImg(scope.row.avatar_url)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="add_time" label="访问时间"></el-table-column>
        <el-table-column prop="page_url" label="页面地址"></el-table-column>
        <el-table-column prop="page_name" label="页面名称"></el-table-column>
        <el-table-column fixed="right" label="操作" width="200px">
          <template slot-scope="scope">
            <!-- 未筛选 -->
            <el-button
              @click="handleRemarkState(1, scope.row, scope.$index, tableData)"
              type="success"
              size="small"
              v-if="scope.row.status === 1"
              >通过</el-button
            >
            <el-button
              @click="handleRemarkState(2, scope.row, scope.$index, tableData)"
              type="danger"
              size="small"
              v-if="scope.row.status === 1"
              >不通过</el-button
            >
            <!-- 已通过 -->
            <el-button
              @click="handleRemarkState(3, scope.row, scope.$index, tableData)"
              type="primary"
              size="small"
              v-if="scope.row.status === 2"
              >置顶</el-button
            >
            <el-button
              @click="handleRemarkState(4, scope.row, scope.$index, tableData)"
              type="danger"
              size="small"
              v-if="scope.row.status === 2"
              >下架</el-button
            >
            <!-- 未通过 -->
            <el-button
              @click="handleRemarkState(5, scope.row, scope.$index, tableData)"
              type="danger"
              size="small"
              v-if="scope.row.status === 3"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import debounce from "@/utils/debounce";
import { msgList, changeStatus, msgDel, msgTop } from "@/api/remark";
export default {
  name: "malRemark",
  data() {
    return {
      type: 1, // 1:穴位  2:病症
      keyword: "", // 搜索关键词
      tableData: [], // 显示数据
      total: 0, // 数据总数
      currentPage: 1, // 当前页面
      pageSize: 10, // 单页数量
      stateList: [
        // 类型选择列表
        { status: 1, name: "未筛选" },
        { status: 2, name: "已通过" },
        { status: 3, name: "未通过" },
      ],
      dataType: 1, // 数据显示类型 1:未筛选 2:已通过 3:未通过
      listStatus: 1,
      previewList: [],
    };
  },
  watch: {
    // 选择类型
    dataType(val) {
      this.$store.dispatch("fullscreenLoading", true);
      this.listStatus = val;
      this.getData();
    },
    keyword() {
      debounce(() => {
        this.currentPage = 1;
        this.$store.dispatch("fullscreenLoading", true);
        this.getData();
      }, 800);
    },
  },
  created() {
    this.$store.dispatch("fullscreenLoading", true);
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 获取数据
    getData() {
      msgList({
        type: this.type,
        keyword: this.keyword,
        status: this.listStatus,
        page: this.currentPage,
        limit: this.pageSize,
      }).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.$store.dispatch("fullscreenLoading", false);
      });
    },
    /**
     * 查看图片
     * @param {string} url - 图片地址
     */
    previewImg(url) {
      this.previewList = [url];
    },
    // 删除
    deleteRow(row, index, tableData) {
      tableData.splice(index, 1);
    },
    // 留言操作
    handleRemarkState(state, row, index, tableData) {
      switch (state) {
        case 1: // 未筛选  通过
          this.$confirm("是否确认通过该留言?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            changeStatus({
              id: row.id,
              action: 2,
            }).then(() => {
              this.getData();
              this.$message.success("留言已通过");
            });
          });
          break;
        case 2: // 未筛选  不通过
          this.$confirm("确认不通过该留言?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            changeStatus({
              id: row.id,
              action: 3,
            }).then(() => {
              this.getData();
              tableData.splice(index, 1);
              this.$message.success("设置成功");
            });
          });
          break;
        case 3: // 已通过  置顶
          this.$confirm("是否要置顶该留言?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            msgTop({
              id: row.id,
            }).then(() => {
              this.getData();
            });
            this.$message.success("置顶成功");
          });
          break;
        case 4: // 已通过  下架
          this.$confirm("是否要下架该留言?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            msgDel({
              id: row.id,
            }).then(() => {
              this.getData();
              this.$message.success("下架成功");
            });
          });
          break;
        case 5: // 未通过  删除
          this.$confirm("是否要删除该留言?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            msgDel({
              id: row.id,
            }).then(() => {
              this.getData();
              this.$message.success("删除成功");
            });
          });
          break;
        default:
          break;
      }
    },
    // 改变单页数量
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
      this.$store.dispatch("fullscreenLoading", true);
    },
    // 切换页面
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
  },
};
</script>

<style scoped>
.header-flex h1 {
  margin: 0;
  padding: 0;
}

.input-flex {
  flex: 1;
  text-align: right;
}

.input {
  width: 200px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 15px;
}

/* 选择类型 */
.select-type {
  margin-right: 15px;
  width: 150px;
}

/* 用户头像 */
.user-avatar {
  width: 40px;
  height: 40px;
}
</style>
